<template>
  <div class="edrea_tm_section" id="about">
    <div class="section_inner">
      <div class="edrea_tm_about">
        <div class="left">
          <div class="image">
           <img src="img/about/Wizard.png" alt="" />
            <div class="main" data-img-url="img/about/Wizard.png"></div>
          </div>
        </div>
        <div class="right">
          <div class="short">
            <h3 class="name">OzTech <span class="coloring">Creative</span></h3>
            <h3 class="job">
              <AnimationText />
            </h3>
          </div>
          <div class="text">
            <p>
               At <span>Oztech Creative,</span> we turn ideas into real, working digital solutions. We are a multidisciplinary team of developers and designers, led by a dedicated project manager who oversees every project from concept to launch. From custom website development to logo design, website content, and social media content creation, we provide everything a business needs to succeed online. Through clear communication, structured planning, and reliable execution, we deliver end-to-end digital solutions that help our clients grow with confidence. </p>
          </div>
          
          <div class="edrea_tm_button" id="aboutPopup">
            <a href="#">Learn More</a> 
          </div>   
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimationText from "./AnimationText.vue";
export default {
  name: `AboutComponent`,
  data() {
    return {
      open: false,
    };
  },
  components: {
    AnimationText,
  },
};
</script>

<style scoped>
.edrea_tm_modalbox {
  top: -90px;
}
/* This adds a subtle, professional dark background behind your text */
.text p {
    background: rgba(53, 53, 53, 0.6); /* Black with 60% transparency */
    padding: 20px;                 /* Space between text and the box edge */
    border-radius: 10px;           /* Rounds the corners to match your buttons */
    line-height: 1.6;              /* Makes the text easier to read */
    backdrop-filter: blur(5px);    /* Optional: slightly blurs the dots behind it */
    color: #e4e4e4;                /* Ensures text remains crisp white */
}
.image {
  bottom: -0.3cm;
}
</style>
